import React from "react"
import styled from "styled-components"

import tokens from "../_tokens"

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  padding: ${tokens.size.base}px ${1.5 * tokens.size.base}px;
  color: ${({ isHighlighted }) =>
    isHighlighted ? tokens.color.text.invert : tokens.color.text.base};
  background: ${({ isHighlighted }) =>
    isHighlighted ? tokens.color.primary : "transparent"};
  cursor: pointer;
`

const StyledText = styled.span`
  font-size: ${tokens.fontSize.text.xs};
  color: ${({ isHighlighted }) =>
    isHighlighted ? tokens.color.text.invert : tokens.color.text.base};
`

const StyledNoResults = styled.div`
  padding: ${tokens.size.base}px;
  font-size: ${tokens.fontSize.text.base};
  color: ${tokens.color.text.base};
  width: 100%;
`

function SearchResults({ results, getItemProps, highlightedIndex }) {
  if (results.length === 0) {
    return <StyledNoResults>No results</StyledNoResults>
  }

  return results.map((item, index) => {
    return (
      <StyledContainer
        isHighlighted={highlightedIndex === index}
        key={item.path || item.item.path}
        {...getItemProps({
          item: item.item || item,
        })}
      >
        <StyledText isHighlighted={highlightedIndex === index}>
          /{item.path || item.item.path}
        </StyledText>
        {item.title || item.item.title}
      </StyledContainer>
    )
  })
}

export default SearchResults
